// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__UCKkZ","footerWrapper":"Footer_footerWrapper__uB6e1","footerCol":"Footer_footerCol__jz6eu","email":"Footer_email__C0nsT"};